import Breadcrumbs from 'components/BreadcrumbsComponent';
import CompetencyForm from 'components/forms/dacum/CompetencyForm';
import React from 'react';
import { pathnames } from 'routes/dacum';
import { useCompetencyManagementStore } from 'store/competencyManagement';

const EditCompetencyPage = () => {
  const { mode } = useCompetencyManagementStore();
  const breadcrumbs = [
    { title: 'Competency Management', href: pathnames.competencyManagement },
    { title: mode === 'add' ? 'New' : 'Edit' + ' ' + 'Competency', href: '' }
  ];
  return (
    <>
      <Breadcrumbs items={breadcrumbs} mb={32} />
      <CompetencyForm />
    </>
  );
};

export default EditCompetencyPage;
